import { Box, Button, Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

export function ForbiddenPage() {
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Stack spacing={2} alignItems="center">
        <Typography variant="h3">403</Typography>
        <Typography color="text.secondary">권한이 없는 페이지입니다.</Typography>
        <Button variant="contained" onClick={() => navigate('/dashboard', { replace: true })}>
          대시보드로
        </Button>
      </Stack>
    </Box>
  );
}
